module.exports = __webpack_public_path__ + "static/media/medical-q-icon-active.629881eb.svg";